import { render, staticRenderFns } from "./ChatFansHome.vue?vue&type=template&id=dbe92f96&"
import script from "./ChatFansHome.vue?vue&type=script&lang=js&"
export * from "./ChatFansHome.vue?vue&type=script&lang=js&"
import style0 from "./ChatFansHome.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports